import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation(); // دریافت مسیر فعلی از React Router

  useEffect(() => {
    // پس از هر تغییر مسیر، اسکرول به بالای صفحه انجام می‌شود
    window.scrollTo(0, 0);
  }, [location]); // این اثر هر بار که location تغییر می‌کند، اجرا می‌شود

  return null; // این کامپوننت هیچ چیزی نمایش نمی‌دهد
};

export default ScrollToTop;
